import type { CollectionModelDrawableLine } from '../../model';
import type { SVGRenderOptions } from '../draw/svg/svg.render';
import { m } from '../mithril';
import { ClassNames, StyleConfig } from '../theme';
import { LabelSVGDraw } from './label.draw.svg';
import { IkeDrawLabel } from './util.draw.svg';
import { SVGUtil } from './util.draw.svg';

const MARKER_CIRCLE_RADIUS = 6;

function getPointStyle(isInsight: boolean, isHovered: boolean, isSelected: boolean) {
	var pointFillColor = StyleConfig.LABEL.FILL;
	var pointStrokeColor = StyleConfig.LABEL.STROKE;

	if (isInsight) {
		pointFillColor = StyleConfig.LABEL.FILL_INSIGHT;
		if (isHovered) {
			pointStrokeColor = StyleConfig.LABEL.FILL_INSIGHT;
		} else {
			pointStrokeColor = StyleConfig.STROKE;
		}
	} else {
		if (isHovered) {
			pointFillColor = StyleConfig.LABEL.FILL_HIGHLIGHTED;
		} else if (isSelected) {
			pointFillColor = StyleConfig.LABEL.FILL_SELECTED;
			pointStrokeColor = StyleConfig.STROKE;
		}
	}

	return {
		fill: pointFillColor,
		stroke: pointStrokeColor,
	};
}
export class LineSVGDraw {
	static view(node: CollectionModelDrawableLine, options: SVGRenderOptions) {
		const startPoint = node.start;
		const endPoint = node.end;
		const label = node.label;
		const selectedId = options.draw.state.selectedId;
		const hoverId = options.draw.state.hoverId;

		// If the current element is an insight one, but we don't have the ability to view them, then don't render it.
		if (node.isInsightMeasurement && !options.isInsightMarkersVisible) {
			return null;
		}

		const isStartSelected = selectedId === startPoint.id;
		const isEndSelected = selectedId === endPoint.id;
		const isSelected = selectedId === node.id || isStartSelected || isEndSelected;

		const isHovered = hoverId === node.id || hoverId === startPoint.id || hoverId === endPoint.id;
		const isActive = isSelected || isHovered;

		const classNames = [
			ClassNames.line.container,
			isSelected ? ClassNames.isSelected : null,
			isHovered ? ClassNames.isHighlighted : null,
		];

		const startPointClassNames = [
			ClassNames.line.start,
			isStartSelected ? ClassNames.isSelected : null,
			isStartSelected ? ClassNames.point.isSelected : null,
		];
		const startPointStyle = getPointStyle(
			node.isInsightMeasurement,
			hoverId === startPoint.id,
			isStartSelected || selectedId === node.id
		);
		const endPointClassNames = [
			ClassNames.line.end,
			isEndSelected ? ClassNames.isSelected : null,
			isEndSelected ? ClassNames.point.isSelected : null,
		];
		const endPointStyle = getPointStyle(node.isInsightMeasurement, hoverId === endPoint.id, isEndSelected);

		const children = [
			SVGUtil.DrawLineMain(startPoint, endPoint, options.scale),
			SVGUtil.DrawLineSecondary(
				startPoint,
				endPoint,
				options.scale,
				node.isInsightMeasurement ? StyleConfig.STOKE_SECONDARY_INSIGHT : StyleConfig.STROKE_SECONDARY
			),

			LabelSVGDraw.view(label, options),

			SVGUtil.DrawMoveLine(startPoint, endPoint, options.scale, IkeDrawLabel.LABEL),

			isActive
				? SVGUtil.DrawPoint(startPoint, {
						className: startPointClassNames.join(' '),
						label: IkeDrawLabel.START,
						radius: options.scale * MARKER_CIRCLE_RADIUS,
						scale: options.scale,
						fill: startPointStyle.fill,
						stroke: startPointStyle.stroke,
						draggable: true,
						nodeId: startPoint.id,
					})
				: null,
			isActive
				? SVGUtil.DrawPoint(endPoint, {
						className: endPointClassNames.join(' '),
						label: IkeDrawLabel.END,
						radius: options.scale * MARKER_CIRCLE_RADIUS,
						scale: options.scale,
						fill: endPointStyle.fill,
						stroke: endPointStyle.stroke,
						draggable: true,
						nodeId: endPoint.id,
					})
				: null,
		];

		return m(
			'g',
			{
				key: node.id,
				className: classNames.join(' '),
				'c-Draw-node-id': node.id,
				'c-Draw-tag': 'line',
			},
			children
		);
	}
}
